import { render, staticRenderFns } from "./OrgViewOrgTimelineCard.vue?vue&type=template&id=6c4633d9&"
import script from "./OrgViewOrgTimelineCard.vue?vue&type=script&lang=js&"
export * from "./OrgViewOrgTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports